import { memo, useState, useCallback } from "react";
import { Row, Col, Input, Button } from "components";
import { fetchBackend } from "helpers";
import { useGlobalContext } from "context/GlobalContext";
import { phoneRegExp } from "constants/index";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SchemaContact = yup.object().shape({
  name: yup.string().required("Ingrese un nombre para continuar"),
  relation: yup.string().required("Ingrese el parentesco para continuar"),
  phoneNumber: yup
    .string()
    .length(10, "El número de teléfono debe tener 10 caracteres")
    .matches(phoneRegExp, "El número de teléfono no es válido"),
});

export const FormContact = memo(({ isUpdate, data = {} }) => {
  const [loading, setLoading] = useState(false);
  const gContext = useGlobalContext();

  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(SchemaContact),
  });

  const updateContact = async (newObj) => {
    const { error } = await fetchBackend({
      method: "put",
      url: `contact/${data._id}`,
      data: newObj,
    });

    if (!error) {
      setLoading(false);
      gContext.toggleContactModal(null);
      setTimeout(() => window.location.reload(), 250);
    } else {
      setLoading(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar actualizar el contacto, revisa la información",
        type: "error",
      });
    }
  };

  const addContact = async (obj) => {
    const { error } = await fetchBackend({
      method: "post",
      url: "contact",
      data: obj,
    });

    if (!error) {
      setLoading(false);
      gContext.toggleContactModal(null);
      setTimeout(() => window.location.reload(), 250);
    } else {
      setLoading(false);

      gContext.toggleAlert({
        message:
          "Hubo un error al intentar registrar el contacto, revisa la información",
        type: "error",
      });
    }
  };

  const handleUploadData = async (obj) => {
    setLoading(true);
    // console.log(obj);
    if (isUpdate) {
      await updateContact(obj);
    } else {
      await addContact(obj);
    }
  };

  const onSubmit = useCallback(
    async ({ name, phoneNumber, relation }) => {
      const obj = {
        name,
        phoneNumber,
        relation,
        user: data.user || gContext.currentUser?._id,
      };

      handleUploadData(obj);
    },
    [data, gContext.currentUser]
  );

  if (!data) return null;

  return (
    <>
      <Row start="xs">
        <Col xs={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Input
                md={12}
                label="Nombre(s)"
                name="name"
                placeholder="Ingresa un nombre(s)"
                defaultValue={data?.name}
                ref={register}
                error={errors.name?.message}
              />
              <Input
                md={6}
                label="Número de contacto"
                type="number"
                name="phoneNumber"
                placeholder="Número de contacto"
                defaultValue={data?.phoneNumber}
                ref={register}
                error={errors.phoneNumber?.message}
              />
              <Input
                md={6}
                label="Tipo de Relación"
                name="relation"
                placeholder="Ingresa el tipo de relación con la persona"
                defaultValue={data?.relation}
                ref={register}
                error={errors.relation?.message}
              />

              <Col md={12} className="mt4">
                <Button
                  htmlType="submit"
                  type="primary"
                  className="w-100"
                  loading={loading}
                >
                  Agregar
                </Button>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
    </>
  );
});
